import React, { useEffect, useState } from 'react';
import { Box, Link, Spinner, Text, VStack } from '@chakra-ui/react';
import { loadToolCredentials } from './toolCredentials';

// This explanation prioritizes what unlocks the tool, then account setup.
export default function ToolCredentialDetails({ tool, disconnected, expired }) {
  const [state, setState] = useState({ loading: true, credentials: [] });
  useEffect(() => {
    let active = true;
    setState({ loading: true, credentials: [] });
    loadToolCredentials(tool?.id).then(credentials => {
      if (active) setState({ loading: false, credentials });
    }).catch(() => {
      if (active) setState({ loading: false, credentials: [] });
    });
    return () => { active = false; };
  }, [tool?.id]);
  const credentials = state.credentials.filter(Boolean);
  return <VStack align="stretch" spacing={5} fontSize="xl" overflowWrap="anywhere">
    <Text>{tool?.name || 'This tool'} requires an additional credential before you can select it.</Text>
    {state.loading ? <Box role="status"><Spinner size="sm" mr={3} />Loading credential requirements…</Box> : <>
      {credentials.length > 0 && <>
        <Text fontWeight={600}>{state.credentials.length > 1 ? 'Earn one of these credentials:' : 'Required credential:'}</Text>
        {credentials.map(credential => <Box key={credential.id} borderWidth="1px" borderColor="gray.200" rounded="lg" p={4}>
          <Text fontWeight={700}>{credential.name}</Text>
          {credential.description && <Text mt={2} whiteSpace="pre-line">{credential.description}</Text>}
          {credential.criteria && <Text mt={3} whiteSpace="pre-line">{credential.criteria}</Text>}
          {credential.url && <Link display="inline-flex" alignItems="center" minH="48px" mt={2} color="blue.700" textDecoration="underline" href={credential.url} isExternal>How to earn this credential</Link>}
          {!credential.criteria && !credential.url && <Text mt={3}>Ask space staff how to earn this credential.</Text>}
        </Box>)}
      </>}
      {(credentials.length === 0 || credentials.length !== state.credentials.length) && <Text>Some credential details are unavailable. Ask space staff which credential you need and how to earn it.</Text>}
    </>}
    <Box borderTopWidth="1px" borderColor="gray.200" pt={4} color="gray.600" fontSize="lg">
      <Text fontWeight={600}>Already earned the credential?</Text>
      <Text mt={2}>{expired ? 'Reconnect your badges connection from your Profile page.' : disconnected ? 'Connect your Parchment Digital Badges account from your Profile page.' : 'Check that your Parchment Digital Badges account is connected on your Profile page. Ask space staff for help if access is still unavailable.'}</Text>
    </Box>
  </VStack>;
}
